module.exports = __webpack_public_path__ + "img/11.8f5578b4.jpg";